import {
	updateProductTitle,
	mapProduct,
	getPaymentType,
	getNumberType,
	updateProductGradingValue,
	getSignInMethodUsed,
} from "../helpers/ecommerceTrackingHelper";

const trackOrderConfirmation = (orderId, terminals, customer) => {
	return {
		sc_events: {
			purchase: 1, // very important
		},
		site_section: "P-Nettbutikk",
		eVar13_signedInService: "Mine Sider",
		order_id: orderId || null, // order_id value
		orderConfig: orderConfig(terminals),
		products: products(terminals, customer),
		productCategories: productCategories(terminals),
		productNames: productNames(terminals),
		productIDs: productIDs(terminals),
		productCounts: productCounts(terminals),
		productPrices: productPrices(terminals),
	};
};

const trackOrderClickAndCollect = (data, product) => {
	return {
		sc_events: {
			event3: 1, //  represents click n collect
		},

		storeId: data.storeId,
		productId: data.webonProductId,
		product,
	};
};

const getMappedProduct = (item, customer) =>
	mapProduct(
		item.metadata.category,
		`${updateProductTitle(item.metadata.name)} ${
			item.type === "hardware" && item.metadata?.description ? updateProductTitle(item.metadata.description) : ""
		}`,
		item.data.id,
		getPriceForPaymentType(item, item.isVatExempt),
		item.metadata.brand,
		item.metadata.name,
		item.metadata.memory,
		item.metadata.color,
		item.metadata.subCategory,
		item.type == "subscription" ? getNumberType(item) : null,
		getPaymentType(item),
		updateProductGradingValue(item.metadata?.condition),
		getSignInMethodUsed(customer),
		hasMemberPrice(item),
		item.metadata?.badge?.toLowerCase().includes("ferdig påsatt"),
		item.metadata?.deliveryDetails?.deliveryService,
	);

const products = (terminals, customer) => {
	const products = [];

	for (const item of terminals) {
		products.push(getMappedProduct(item, customer));

		for (const subItem of item?.subItems || []) {
			products.push(getMappedProduct(subItem, customer));
		}
	}

	return products.join(",");
};

const productCategories = (terminals) => {
	const categories = [];

	for (const item of terminals) {
		categories.push(item?.metadata?.category);

		for (const subItem of item?.subItems || []) {
			categories.push(subItem?.metadata?.category);
		}
	}

	return categories;
};

const productNames = (terminals) => {
	const productNames = [];

	for (const item of terminals) {
		if (item.metadata) {
			productNames.push(item?.metadata?.name?.replaceAll(",", ""));

			for (const subItem of item.subItems) {
				if (subItem?.metadata) {
					productNames.push(subItem?.metadata?.name?.replaceAll(",", ""));
				}
			}
		}
	}

	return productNames;
};

const productIDs = (terminals) => {
	const productIDs = [];

	for (const item of terminals) {
		productIDs.push(item.data?.id);

		for (const subItem of item.subItems) {
			productIDs.push(subItem.data?.id);
		}
	}

	return productIDs;
};

const productCounts = (terminals) => {
	const counts = [];

	terminals.forEach((item) => {
		counts.push(1);
		item.subItems?.forEach(() => counts.push(1));
	});

	return counts;
};

const productPrices = (terminals) => {
	const prices = [];

	for (const item of terminals) {
		prices.push(getPriceForPaymentType(item, item.isVatExempt) || "0");

		for (const subItem of item?.subItems || []) {
			prices.push(getPriceForPaymentType(subItem, item.isVatExempt) || "0");
		}
	}

	return prices;
};

const getPriceForPaymentType = (item, isVatExempt = false) => {
	let price;

	const paymentType = getPaymentType(item);

	if (paymentType?.includes("SWAP")) {
		price = item.metadata?.saleRecurringPrice || item.metadata?.swapMonthlyPrice;
	} else if (paymentType?.includes("Nedbetaling")) {
		price =
			(item.metadata?.salePriceWithVat || item.metadata?.priceWithVat) / (item.metadata?.installmentsInMonths || 24);
	} else if (item.type === "subscription" || item.type === "agreement") {
		price = item.metadata?.recurringPrice;
	} else {
		if (isVatExempt) {
			if (item.metadata.memberPrice?.prices) {
				price = item.metadata.memberPrice.prices.withoutVat?.memberPrice;
			} else {
				price = item.metadata.salePriceWithoutVat || item.metadata.priceWithoutVat;
			}
		} else {
			if (item.metadata.memberPrice?.prices) {
				price = item.metadata.memberPrice.prices.withVat.memberPrice;
			} else {
				price = item.metadata?.salePrice || item.metadata?.price;
			}
		}
	}

	return Math.round(price);
};

const hasMemberPrice = (item) => {
	const memberPrice = item?.metadata?.memberPrice?.prices ? item.metadata.memberPrice : null;
	const paymentType = getPaymentType(item);

	if (memberPrice && paymentType === "Fullpris+Abo") {
		return true;
	}

	return false;
};

const orderConfig = (terminals) => {
	const configs = [];

	for (const item of terminals) {
		if (item?.type !== "msisdn") {
			configs.push({
				productName: `${updateProductTitle(item.metadata.name)} ${
					item.type === "hardware" && item.metadata?.description ? updateProductTitle(item.metadata.description) : ""
				}`,
				productPrice: getPriceForPaymentType(item, item.isVatExempt),
				category: item?.metadata?.category,
				orderType: null, // TODO: Need to figure this one out
				numberType: null, // TODO: Need to figure this one out
			});
		}
		for (const subItem of terminals?.subItems || []) {
			if (subItem?.type !== "msisdn") {
				for (const subItem of item?.subItems || []) {
					configs.push({
						productName: `${updateProductTitle(subItem.metadata?.name)} ${
							subItem.type === "hardware" && subItem.metadata?.description
								? updateProductTitle(subItem.metadata?.description)
								: ""
						}`,
						productPrice: getPriceForPaymentType(subItem, item.isVatExempt),
						category: subItem?.metadata?.category,
						orderType: null, // TODO: Need to figure this one out
						numberType: null, // TODO: Need to figure this one out
					});
				}
			}
		}
	}

	return configs;
};

export { trackOrderConfirmation, trackOrderClickAndCollect };
